/* tslint:disable */
/* eslint-disable */
/**
 * NoRadio Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FileUrl } from './FileUrl';
import { FileUrlFromJSON, FileUrlFromJSONTyped, FileUrlToJSON } from './FileUrl';
import type { ShowModelResponse } from './ShowModelResponse';
import {
    ShowModelResponseFromJSON,
    ShowModelResponseFromJSONTyped,
    ShowModelResponseToJSON,
} from './ShowModelResponse';

/**
 *
 * @export
 * @interface ResponseGetShowApiV1ShowsShowGet
 */
export interface ResponseGetShowApiV1ShowsShowGet {
    /**
     *
     * @type {any}
     * @memberof ResponseGetShowApiV1ShowsShowGet
     */
    id: any | null;
    /**
     *
     * @type {any}
     * @memberof ResponseGetShowApiV1ShowsShowGet
     */
    title: any | null;
    /**
     *
     * @type {any}
     * @memberof ResponseGetShowApiV1ShowsShowGet
     */
    type: any | null;
    /**
     *
     * @type {FileUrl}
     * @memberof ResponseGetShowApiV1ShowsShowGet
     */
    fileUrl?: FileUrl;
}

/**
 * Check if a given object implements the ResponseGetShowApiV1ShowsShowGet interface.
 */
export function instanceOfResponseGetShowApiV1ShowsShowGet(value: object): boolean {
    if (!('id' in value)) return false;
    if (!('title' in value)) return false;
    if (!('type' in value)) return false;
    return true;
}

export function ResponseGetShowApiV1ShowsShowGetFromJSON(
    json: any,
): ResponseGetShowApiV1ShowsShowGet {
    return ResponseGetShowApiV1ShowsShowGetFromJSONTyped(json, false);
}

export function ResponseGetShowApiV1ShowsShowGetFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ResponseGetShowApiV1ShowsShowGet {
    if (json == null) {
        return json;
    }
    return {
        id: json['id'],
        title: json['title'],
        type: json['type'],
        fileUrl: json['file_url'] == null ? undefined : FileUrlFromJSON(json['file_url']),
    };
}

export function ResponseGetShowApiV1ShowsShowGetToJSON(
    value?: ResponseGetShowApiV1ShowsShowGet | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        id: value['id'],
        title: value['title'],
        type: value['type'],
        file_url: FileUrlToJSON(value['fileUrl']),
    };
}
